import { useContext, useMemo } from "react";
import { AppContext } from "../../../common";
import { toast } from "react-toastify";

export const useValidateOvertimeSchedule = () => {
  const { startDateScheduling, endDateScheduling, selectedEmployees } =
    useContext(AppContext);

  const employeesList = useMemo(() => {
    return selectedEmployees
      .filter((e) => !e.droppable)
      .map((e) => Number(e.id));
  }, [selectedEmployees]);

  const isValid = useMemo(() => {
    const hasValidDates =
      !!startDateScheduling &&
      startDateScheduling !== "" &&
      !!endDateScheduling &&
      endDateScheduling !== "";

    return hasValidDates && employeesList.length > 0;
  }, [startDateScheduling, endDateScheduling, employeesList]);

  const validate = () => {
    if (!isValid) {
      toast.warning("Por favor selecciona fecha inicial, final y empleado", {
        autoClose: 5000,
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return false;
    }
    return true;
  };

  return {
    isValid,
    validate,
    employeesList,
    startDateScheduling,
    endDateScheduling,
  };
};
